






















import Vue from "vue";
import QrcodeVue from "qrcode.vue";
import Shared from "../../../shared";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "ShareDocument",
    components: { QrcodeVue },
    props: {
        documentId: String,
        quickCode: String
    },
    data: function () {
        return {};
    },
    computed: {
        hasQuickCode(): boolean {
            return this.quickCode && this.quickCode.length > 1;
        },
        link(): string {
            if (this.hasQuickCode) {
                return Shared.iProvaUrl + "/QC/" + this.quickCode;
            } else {
                return location.href.replace(location.hash, "#/document/" + this.documentId);
            }
        }
    },
    methods: {
        async copyLink(): Promise<boolean> {
            this.selectTextToCopy();
            document.execCommand("copy");
            return false;
        },
        selectTextToCopy(): void {
            let textToCopy = (this.$refs.link as Vue).$el.querySelector("input");
            textToCopy.select();
        },
        getCanvas(): HTMLCanvasElement {
            return document.getElementById("qrCode").getElementsByTagName("canvas")[0];
        },
        saveQrIE(canvas: HTMLCanvasElement) {
            (window.navigator as any).msSaveBlob((canvas as any).msToBlob(), "QRCode.png");
        },
        blurDownloadButtonIE(): void {
            this.$nextTick(() => {
                document.getElementById("qrCode").focus();
            });
        },
        saveQrChrome(canvas: HTMLCanvasElement) {
            let link = document.createElement("a");
            link.download = "QRCode.png";
            link.href = canvas.toDataURL();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        canUseMsSaveBlob(): boolean {
            if ((window.navigator as any).msSaveBlob) {
                return true;
            } else {
                return false;
            }
        },
        download(): void {
            let canvas = this.getCanvas();
            if (this.canUseMsSaveBlob()) {
                this.saveQrIE(canvas);
                this.blurDownloadButtonIE();
            } else {
                this.saveQrChrome(canvas);
            }
        }
    },
    async created() {
        //register handler for dialog OK button
        this.registerHandlers({ ok: this.copyLink });
    }
});
